var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"grid",staticClass:"MASONRY-COLUMNS"},[_vm._t("default",null,{"calculateCellPositions":_vm.debouncedOnWindowResize})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }